var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.account.iceAgent)?_c('FormErrorAlert',{attrs:{"alert-type":"warning","dismissable":false,"heading":"Warning","message":"The results may not be complete due to restricted data for ICE users."}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }